import { useEffect } from 'react';
import { Field, formikHelpers } from '@round/creatorbase-ui';
import { TargetChip, TargetChips } from '../TargetChips/TargetChips';
import { TargetChipsInput } from '../TargetChips/TargetChipsInput';
import { getSoundName, SoundChip } from './SoundChip';
import { SoundChipState, useSoundChips } from './useSoundChips';

const { Field: FormikField } = formikHelpers;

const INPUT_LABEL = 'Sounds';

type Props = {
    disabled?: boolean;
    /** The submit gate: the endpoint takes ids, so Create waits for every chip to hold one. */
    onResolvingChange?: (isResolving: boolean) => void;
};

/**
 * A sound is pasted as a TikTok music link or a bare id and stored as a `Music` id, so unlike a
 * hashtag it is not a target until Round has been asked what it stands for.
 */
export const SoundTargets = ({ disabled, onResolvingChange }: Props) => {
    const { chips, isResolving, limitMessage, add, remove } = useSoundChips();

    useEffect(() => {
        onResolvingChange?.(isResolving);
    }, [isResolving, onResolvingChange]);

    return (
        <FormikField name="audios">
            <FormikField.Title>{INPUT_LABEL}</FormikField.Title>
            <TargetChipsInput
                label={INPUT_LABEL}
                placeholder="Paste TikTok sound links or IDs, then press Enter"
                disabled={disabled}
                onAdd={add}
            />

            {limitMessage && <Field.Error>{limitMessage}</Field.Error>}
            <FormikField.Error name="audios" />

            <TargetChips chips={getChips(chips)} disabled={disabled} onRemove={remove} />
        </FormikField>
    );
};

const getChips = (sounds: SoundChipState[]): TargetChip[] =>
    sounds.map((sound) => ({ key: sound.key, name: getSoundName(sound), label: <SoundChip chip={sound} /> }));
